import { z } from "zod";

// ── Route 29: GET /api/edits ──────────────────────────────────────

/**
 * Single content edit row returned inside EditsListResponse.
 */
export const EditRow = z.object({
  id: z.string(),
  content_id: z.string(),
  edit_type: z.string(),
  target: z.object({
    original_href: z.string().optional(),
    original_text: z.string().optional(),
  }),
  before: z.object({
    href: z.string().optional(),
    text: z.string().optional(),
  }),
  after: z.object({
    href: z.string().optional(),
    text: z.string().optional(),
  }),
  reason: z.string(),
  confidence: z.number().nullable(),
  status: z.string(),
  proposed_at: z.string(),
  actor_id: z.string(),
  batch_id: z.string().nullable(),
});
export type EditRow = z.infer<typeof EditRow>;

/**
 * Wire-level response for GET /api/edits.
 * Returns a filtered, paginated list of content edit rows.
 */
export const EditsListResponse = z.object({
  edits: z.array(EditRow),
});
export type EditsListResponse = z.infer<typeof EditsListResponse>;

// ── Routes 30-31: POST /api/edits/:editId/approve|reject ─────────

/**
 * Wire-level response for POST /api/edits/:editId/approve and
 * POST /api/edits/:editId/reject.
 * Returns a simple acknowledgement envelope.
 */
export const EditActionResponse = z.object({
  ok: z.literal(true),
});
export type EditActionResponse = z.infer<typeof EditActionResponse>;
